<div class="flex w-full" #stepContainer>
  <div class="pt-[2px] relative">
    <rk-step-status-icon [status]="status"></rk-step-status-icon>
    @if (showFlowLine) {
      <div
        class="flow-line"
        [class.completed]="flowLineCompleted"
        [class.expanding]="isExpanding"
        [class.in-progress]="status === 'in_progress'"
        [style.height.px]="flowLineHeight"
      ></div>
    }
  </div>
  <div class="w-full">
    <rk-publishing-step-panel
      [name]="stepContent?.label | translate"
      [isOpen]="isOpen"
      (toggleStep)="handleStepToggle()"
      [tag]="getStatusTag(status)"
      [collapsable]="stepContent?.description !== null"
    >
      @if (stepContent?.description) {
        <div class="mb-4 opacity-70">
          {{ stepContent?.description | translate }}
        </div>
      }

      <!-- cta -->
      <div class="flex gap-2">
        @if (stepContent.cta) {
          <rk-button
            [text]="stepContent.cta | translate"
            variant="secondary"
            (buttonClick)="onCtaClick()"
            [disabled]="getCtaIsDisabled(status)"
          >
          </rk-button>
        }

        <!-- shows extra button if step is dev-account -->
        @if (stepType === 'dev-account') {
          <rk-button
            [text]="'publishing-step.existing-dev-account' | translate"
            variant="secondary"
            (buttonClick)="onExistingDevAccountClick()"
            [disabled]="getCtaIsDisabled(status)"
          >
          </rk-button>
        }
      </div>
    </rk-publishing-step-panel>
  </div>
</div>
